import React from "react";
import "./Login.scss";
import PublicAuthFormWrapper from "../components/PublicAuthFormWrapper";
import VerifyEmailForm from "../components/VerifyEmailForm";

export default function PublicVerifyEmail() {
  return (
    <PublicAuthFormWrapper title='Verify Email Address' documentTitle='Verify Email Address'>
      <VerifyEmailForm />
    </PublicAuthFormWrapper>
  );
}
